export default "__VITE_ASSET__CVHtWt1d__"